module.exports = __webpack_public_path__ + "img/powerpoint.68d8c1ce.png";